import { render, staticRenderFns } from "./noteList.vue?vue&type=template&id=53886b38&scoped=true"
import script from "./noteList.vue?vue&type=script&lang=js"
export * from "./noteList.vue?vue&type=script&lang=js"
import style0 from "./noteList.vue?vue&type=style&index=0&id=53886b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53886b38",
  null
  
)

export default component.exports